export default "../../src/img/urspelt_logo.svg";